// extracted by mini-css-extract-plugin
export var compactFilters = "_cs-4";
export var detailImage = "_cs-1";
export var dropdownContainer = "_cs-2";
export var imageContainer = "_cs-0";
export var selectedCard = "_cs-3";